module.exports = __webpack_public_path__ + "img/logo_transport_rf.4b07cbcd.png";